import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import SoftwareDeveloperMind from "./sections/SoftwareDeveloperMind";
import StrategicSolutions from "./sections/StrategicSolutions";
import OurPhilosophy from "./sections/OurPhilosophy";
import WhyAutoMoti from "./sections/WhyAutoMoti";
import ExpertiseInAction from "./sections/ExpertiseInAction";
import Fourpillarflowgraphic from "./sections/Fourpillarflowgraphic";
import Philosophyinterplay from "./sections/Philosophyinterplay";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <SoftwareDeveloperMind />
      <StrategicSolutions />
      <OurPhilosophy />
      <WhyAutoMoti />
      <ExpertiseInAction />
      <Fourpillarflowgraphic />
      <Philosophyinterplay />
      <Footer />
    </div>;
}